import SideBar from "./SideBar";

function Home(){  
    return <>
    <div className="wholeHome">
        <h1>In Home</h1> 

     
        </div>
        
    </>

}

export default Home;